<template>
  <div>
    <!-- 订单绑定：按订单号查询订单商品，并将指定商品明细标识为当前辅料 -->
    <el-dialog title="标识商品为辅料" :close-on-click-modal="false" :visible.sync="dialogVisible" width="1200px" center>
      <!-- 搜索条件 -->
      <div class="search-row">
        <el-input v-model.trim="searchForm.order_sn" placeholder="请输入订单号" clearable @keyup.enter.native="search" />
        <el-button type="primary" :loading="loading" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </div>

      <!-- 商品明细列表 -->
      <el-table :data="pageList" v-loading="loading" :header-cell-style="{ background: '#EDEFF4' }" height="430px"
        border>
        <el-table-column label="NO" type="index" align="center" width="70" />
        <el-table-column label="商品管理番号" align="center" width="180">
          <template slot-scope="scope">
            {{ scope.row.for_sn || scope.row.sorting || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="商品图片" align="center" width="140">
          <template slot-scope="scope">
            <el-image v-if="scope.row.pic" :src="scope.row.pic" fit="cover" class="goods-img"
              :preview-src-list="[scope.row.pic]" />
            <div v-else class="goods-img empty-img"></div>
          </template>
        </el-table-column>
        <el-table-column label="SKU" align="center" width="150">
          <template slot-scope="scope">
            <div class="cell-lines">
              <p v-for="(item, index) in getSku(scope.row)" :key="index">{{ item }}</p>
              <p v-if="!getSku(scope.row).length">-</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="附加服务" align="center" min-width="210">
          <template slot-scope="scope">
            <div class="cell-lines">
              <p v-for="(item, index) in getOptions(scope.row)" :key="index">{{ item }}</p>
              <p v-if="!getOptions(scope.row).length">-</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="备注" align="center" min-width="190">
          <template slot-scope="scope">
            <div class="remark">{{ getRemark(scope.row) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="130" fixed="right">
          <template slot-scope="scope">
            <template v-if="isMarked(scope.row)">
              <div class="marked-text">已标识</div>
              <el-button v-if="isAuth(670)" size="mini" @click="notSign(scope.row)">解除</el-button>
            </template>
            <el-button v-else-if="isAuth(670)" size="mini" type="primary" class="dark"
              @click="sign(scope.row)">标识为辅料</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-row">
        <span>总计 {{ tableData.length }} 件</span>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pageForm.page" :page-sizes="[20, 50, 100]" :page-size="pageForm.pageSize"
          layout="sizes, prev, pager, next, jumper" :total="tableData.length" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'OrderBind',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      material: {},
      searchForm: {
        order_sn: ''
      },
      pageForm: {
        page: 1,
        pageSize: 20
      },
      tableData: []
    }
  },
  computed: {
    // 当前页展示的数据，订单详情接口返回全部商品明细，这里做前端分页
    pageList() {
      const start = (this.pageForm.page - 1) * this.pageForm.pageSize
      return this.tableData.slice(start, start + this.pageForm.pageSize)
    }
  },
  methods: {
    // 打开弹框时记录当前辅料，后续标识接口需要 material_id 和 user_id
    open(material) {
      this.material = material || {}
      this.dialogVisible = true
      this.reset()
    },
    // 按订单号查询订单详情，并取出 order_detail 作为商品明细列表
    search() {
      if (!this.searchForm.order_sn) {
        this.$message.warning('请输入订单号')
        return
      }

      this.loading = true
      this.$api.orderApi.orderDetails({ order_sn: this.searchForm.order_sn }).then(res => {
        const data = res.data || {}
        this.tableData = data.order_detail || []
        this.pageForm.page = 1
      }).finally(() => {
        this.loading = false
      })
    },
    // 重置搜索条件和表格数据
    reset() {
      this.searchForm = {
        order_sn: ''
      }
      this.pageForm.page = 1
      this.tableData = []
    },
    // 标识为辅料，接口参数：user_id、list[{ order_detail_id, material_id }]
    sign(row) {
      if (!this.isAuth(670)) return
      const datas = this.getOperateParams(row)
      this.$api.warehouseApi.sortingSignMaterial(datas).then(res => {
        this.$message.success(res.msg)
        this.search()
        this.$emit('saved')
      })
    },
    // 解除辅料标识，沿用同一组明细参数
    notSign(row) {
      if (!this.isAuth(670)) return
      const datas = {
        orderDetailIds: [row.order_detail_id || row.id]
      }
      this.$api.warehouseApi.sortingNotSignMaterial(datas).then(res => {
        this.$message.success(res.msg)
        this.search()
        this.$emit('saved')
      })
    },
    // 组装标识/解除接口参数
    getOperateParams(row) {
      return {
        user_id: this.material.user_id || '',
        list: [{
          order_detail_id: row.order_detail_id || row.id,
          material_id: this.material.id
        }]
      }
    },
    // 判断当前商品明细是否已标识为当前辅料，兼容接口可能返回的不同字段
    isMarked(row) {
      const materialId = this.material.id
      return row.material_id == materialId ||
        row.materialId == materialId ||
        (row.material && row.material.id == materialId) ||
        (row.material && row.material.material_id == materialId) ||
        row.is_material == 1
    },
    // SKU 展示：优先取业务编辑属性 detail_y，没有则取原始属性 detail
    getSku(row) {
      const detail = row.detail_y && row.detail_y.length ? row.detail_y : row.detail
      if (!detail || !detail.length) return []
      return detail.map(item => `${item.key || ''}${item.value ? '：' + item.value : ''}`)
    },
    // 附加服务展示：名称、数量、价格按接口已有 option 字段拼接
    getOptions(row) {
      if (!row.option || !row.option.length) return []
      return row.option.map(item => {
        const num = item.num ? `*${item.num}` : ''
        const price = item.price ? ` ${item.price}${item.unit || ''}` : ''
        return `${item.name || ''}${num}${price}`
      })
    },
    // 备注展示：按业务备注、客户备注、采购备注顺序兜底
    getRemark(row) {
      return row.y_remark || row.client_remark || row.g_remark || row.p_remark || '-'
    },
    // 切换页码
    handleCurrentChange(val) {
      this.pageForm.page = val
    },
    // 切换每页条数
    handleSizeChange(val) {
      this.pageForm.pageSize = val
      this.pageForm.page = 1
    }
  }
}
</script>

<style lang="scss" scoped>
.search-row {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;

  .el-input {
    width: 280px;
  }
}

.goods-img {
  width: 94px;
  height: 94px;
  background: #d8d8d8;
}

.empty-img {
  display: inline-block;
}

.cell-lines {
  max-height: 96px;
  overflow: hidden;
  line-height: 20px;

  p {
    margin: 0;
  }
}

.remark {
  max-height: 96px;
  overflow: hidden;
  line-height: 20px;
  word-break: break-all;
}

.marked-text {
  margin-bottom: 8px;
  color: #15ad3c;
}

.pagination-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-top: 16px;
}
</style>
